export default function () {
  let allCountries,
    allMarkers,
    allPopups,
    worldmap

  // getters
  function getCountriesByContinent (continent) {
    return worldmap.find('g#' + continent).children()
  }

  function getMarkerByContinent (continent) {
    return worldmap.find('g#markers #' + continent)
  }

  // Countries functions
  function unHighlightAllCountries () {
    allCountries.removeClass('highlight')
  }

  function resetAllCountries () {
    allCountries.removeClass('highlight')
    allCountries.removeClass('active')
  }

  function countriesHighlight (continent) {
    getCountriesByContinent(continent).addClass('highlight')
  }

  function activateCountries (continent) {
    getCountriesByContinent(continent).addClass('active')
  }

  function isNoSelectCountry (continent) {
    return continent == 'noSelect'
  }

  // markers functions

  function highlightMarker (continent) {
    getMarkerByContinent(continent).addClass('highlight')
  }

  function activateMarker (continent) {
    getMarkerByContinent(continent).addClass('active')
    setTimeout(function () {
      hideMarker(continent)
      markersDeActivate()
    }, 400)
  }

  function markersDeActivate () {
    $('#markers .active').removeClass('active')
  }

  function resetAllMarkers () {
    allMarkers.removeClass('highlight').removeClass('active')
  }

  function unHighlightAllMarkers () {
    allMarkers.removeClass('highlight')
  }

  function hideMarker (continent) {
    getMarkerByContinent(continent).addClass('hidden')
  }

  function hideAllMarkers () {
    allMarkers.addClass('hidden')
  }

  function showAllMarkers () {
    allMarkers.removeClass('hidden')
  }

  function deSaturateCountries () {
    allCountries.addClass('desaturate')
  }

  function saturateCountries () {
    allCountries.removeClass('desaturate')
  }

  // Higher level funcitons
  function activateContinent (continent) {
    resetWorldMap()
    if (isNoSelectCountry(continent)) {
      return
    }
    resetAllPopups()
    hideAllMarkers()
    deSaturateCountries()
    activateCountries(continent)
    activateMarker(continent)
    activatePopup(continent)
  }

  function highlightContinent (continent) {
    if (isNoSelectCountry(continent)) {
      return
    }
    countriesHighlight(continent)
    highlightMarker(continent)
  }

  function unHighlightContinents () {
    unHighlightAllCountries()
    unHighlightAllMarkers()
  }

  function resetWorldMap () {
    resetAllPopups()
    resetAllCountries()
    resetAllMarkers()
    showAllMarkers()
    saturateCountries()
  }

  function resetAllPopups () {
    allPopups.removeClass('active')
  }

  function getPopupByContinent (continent) {
    return worldmap.find('.worldmappopup[data-continent="' + continent + '"]')
  }

  function activatePopup (continent) {
    getPopupByContinent(continent).addClass('active')
  }

  $(document).ready(function () {
    worldmap = $('#worldmap')
    allCountries = worldmap.find('g#continents path, g#continents polygon')
    allMarkers = worldmap.find('g#markers').children()
    allPopups = $('.worldmappopup')

    // events on Country shapes
    allCountries.click(function (event) {
      event.stopPropagation()
      activateContinent($(this).parent().attr('id'))
    })

    allCountries.hover(function (event) {
      event.stopPropagation()
      unHighlightContinents()
      highlightContinent($(this).parent().attr('id'))
    }, function () {
      unHighlightContinents()
    })

    // events on Marker shapes
    allMarkers.click(function (event) {
      event.stopPropagation()
      activateContinent($(this).attr('id'))
    })

    allMarkers.hover(function (event) {
      event.stopPropagation()
      unHighlightContinents()
      highlightContinent($(this).attr('id'))
    }, function () {
      // no blur action
    })

    worldmap.click(function () {
      resetWorldMap()
    })

    worldmap.hover(function () {
      unHighlightContinents()
    }, function () {})
  })
}
